import { get, post, put, del} from "@/service/configApi"

export async function fetchMarketEvent(body) {
    return await get(`/market_event/list/admin`, {
        sort: body.sort,
        sortby: body.sortby,
        page: body.page,
        limit: body.limit,
        active: body.active
    })
}

export async function insertMarketEvent(body) {
    return await post(`/market_event/manage/insert`, {
        title : body.name,
        image : body.logoUrl,
    })
}

export async function updateMarketEvent(body) {
    return await put(`/market_event/manage/update`, {
      id: body.id,
      title: body.name,
      image: body.logo,
      active: body.status,
      priority: body.priority,
      levelSub: body.levelSub,
      categories: body.categories
    })
  }

export async function updateActiveMarketEvent(body) {
    return await put(`/market_event/manage/active`, {
        id: body.id,
        active: body.status
      })
}